import React from 'react';

type CopiedToClipboardState = 'success' | 'error';

export const useCopyToClipboard = ({ resetTimeOut = 3000 }: { resetTimeOut?: number } = {}) => {
  const [copiedToClipboard, setCopiedToClipboard] = React.useState<CopiedToClipboardState | null>(
    null
  );

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedToClipboard('success');
    } catch (error) {
      setCopiedToClipboard('error');
      console.error('Failed to copy text: ', error);
    }
  };

  React.useEffect(() => {
    if (copiedToClipboard) {
      setTimeout(() => {
        setCopiedToClipboard(null);
      }, resetTimeOut);
    }
  }, [copiedToClipboard, resetTimeOut]);

  return { copiedToClipboard, copyToClipboard };
};
